<template>
  <base-form :title="title"
             :loading="submitLoading"
             @submit="submitForm">
    <div v-if="model">

      <fg-input :label="$t('jobAlerts.list.frequency')"
                :error="getError($t('jobAlerts.list.frequency'))"
                :name="$t('jobAlerts.list.frequency')">
        <el-select v-model="model.frequency"
                   v-validate="'required'"
                   class="select-default">
          <el-option v-for="option in frequencyOptions"
                     :value="option.value"
                     :label="option.label"
                     :key="option.value"
                     class="select-default"
          ></el-option>
        </el-select>
      </fg-input>

      <fg-input :label="$t('cms.form.active')"
                :error="getError($t('cms.form.active'))"
                :name="$t('cms.form.active')">
        <base-switch v-model="model.active"/>
      </fg-input>

      <section-separator has-border size="lg">
        {{$t('searchSuggestions.list.query')}}
      </section-separator>
      <div class="flex flex-col md:flex-row">
        <fg-input :label="$t('jobAlerts.list.search')"
                  :name="$t('jobAlerts.list.search')"
                  class="w-full md:w-1/2 md:mr-3"
                  v-model="model.query.search">
        </fg-input>
        <fg-input :label="$t('jobAlerts.list.location')"
                  :name="$t('jobAlerts.list.location')"
                  class="w-full md:w-1/2"
                  v-model="model.query.location">
        </fg-input>
      </div>
      <fg-input :label="$t('jobAlerts.list.range')"
                :name="$t('jobAlerts.list.range')">
        <el-select v-model="model.query.range"
                   class="select-default">
          <el-option v-for="option in RANGE_OPTIONS"
                     :value="option.value"
                     :label="`${option.label} ${distanceSymbol}`"
                     :key="option.value"
                     class="select-default"
          ></el-option>
        </el-select>
      </fg-input>
      <div class="flex flex-col md:flex-row">
        <fg-input :label="$t('jobAlerts.list.lat')"
                  :name="$t('jobAlerts.list.lat')"
                  class="w-full md:w-1/2 md:mr-3"
                  v-model="model.query.lat">
        </fg-input>
        <fg-input :label="$t('jobAlerts.list.lon')"
                  :name="$t('jobAlerts.list.lon')"
                  class="w-full md:w-1/2"
                  v-model="model.query.lon">
        </fg-input>
      </div>
      <fg-input :label="$t('generic.segments')">
        <segment-autocomplete :placeholder="$t('generic.segments')"
                              multiple
                              v-model="model.query.segment_ids">
        </segment-autocomplete>
      </fg-input>

    </div>
  </base-form>
</template>
<script>
import flattenDeep from 'lodash/flattenDeep'
import cloneDeep from 'lodash/cloneDeep'
import SegmentAutocomplete from 'src/components/Autocomplete/SegmentAutocomplete'
import { Select, Option } from 'element-ui'
import { RANGE_OPTIONS } from 'src/utils/rangeOptions'

let defaultQuery = {
  segment_ids: [],
  lat: null,
  lon: null,
  range: null,
  search: '',
  location: '',
}
export default {
  components: {
    SegmentAutocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    title: String,
    submitLoading: Boolean,
  },
  data () {
    return {
      RANGE_OPTIONS,
      model: {
        job_board_id: null,
        keyword: '',
        query: {
          ...defaultQuery
        }
      },
      frequencyOptions: [
        {
          value: 'daily',
          label: this.$t('jobAlerts.daily'),
        },
        {
          value: 'weekly',
          label: this.$t('jobAlerts.weekly'),
        },
        {
          value: 'monthly',
          label: this.$t('jobAlerts.monthly'),
        }
      ]
    }
  },
  computed: {
    distanceSymbol () {
      return this.$store.getters['config/distanceSymbol']
    },
    segments() {
      return this.$store.state.config.segments
    }
  },
  methods: {
    async submitForm () {
      let isFormValid = await this.$validator.validateAll()
      if (!isFormValid) {
        return
      }
      const data = cloneDeep(this.model)
      data.query.segment_ids = this.groupSegmentIds(this.model.query.segment_ids)
      this.$emit('submit', data)
    },
    groupSegmentIds(segmentIds) {
      if (!segmentIds) {
        return []
      }
      const finalSegments = []
      for(let key in this.segments) {
        const group = []
        const groupSegments = this.segments[key].map(s => s.id)
        segmentIds.forEach(sgId => {
          if (groupSegments.includes(sgId)) {
            group.push(sgId)
          }
        })
        if (group.length) {
          finalSegments.push(group)
        }
      }
      return finalSegments
    },
    validateQuery (query) {
      if (!query) {
        return {
          ...defaultQuery
        }
      }
      if (!query.segment_ids) {
        query.segment_ids = []
      }
      if (query.range === undefined) {
        query.range = null
      }
      if (query.lat === undefined) {
        query.lat = null
      }
      if (query.lon === undefined) {
        query.lon = null
      }
      if (!query.search) {
        query.search = ''
      }
      if (!query.location) {
        query.location = ''
      }
      query.segment_ids = flattenDeep(query.segment_ids).map(sgId => +sgId)
      return query
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (newVal) {
        if (!newVal) {
          return
        }
        this.model = {
          ...newVal
        }
        this.model.query = this.validateQuery(newVal.query)
      }
    }
  }
}
</script>
<style>
</style>
